import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/Main.vue";
import NotFound from "@/components/NotFound.vue";

Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "NotFound",
      component: NotFound
    },
    {
      path: "/home/:id",
      name: "Home",
      component: Home
    }

    // {
    //   path: "/",
    //   redirect: "/kioskid"
    // },
    // {
    //   path: "*",
    //   redirect: "/kioskid"
    // }
  ]
});

export default router;
